module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }